// Máscara de segredo antes de enviar ou salvar; o servidor aplica a mesma (consultas/suporte_ia/texto.py).

// Chave/token colado no chat: some do texto antes de ir à IA ou de ser salvo.
const RE_SEGREDO = /\b(?:sk|pk|rk)[-_][A-Za-z0-9_-]{16,}|\b(?=[A-Za-z0-9_-]*\d)(?=[A-Za-z0-9_-]*[A-Za-z])[A-Za-z0-9_-]{32,}\b/g;
export const CHAVE_APAGADA = "[chave apagada]";
export const mascararSegredo = (t) => t.replace(RE_SEGREDO, CHAVE_APAGADA);

